<template>
    <Cmembernav :curnavkv="curnavkv" :isnorecord="isnorecord">
        <div class="adminwrap">
            <div class="schoolnav">
                <a href="#" :class="{cs:navsub==0}" @click="getdata(0)">{{$common.dicword('school')}}</a>
                <a href="#" :class="{cs:navsub==1}" @click="getdata(1)">{{$common.dicword('infoclass')}}</a>

                <a href="#" :class="{cs:navsub==3}" @click="getdata(3)">{{$common.dicword('teacher')}}</a>
                <a href="#" :class="{cs:navsub==2}" @click="getdata(2)">{{$common.dicword('learner')}}</a>
            </div>

            <div class="myoptions">
                <el-select v-if="isexpert" v-model="options.schoolid" size="mini" class="memselect" @change="selectschool">
                    <el-option v-for="item in schoollist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                </el-select>
                <template v-if="navsub>0">
                    <el-select v-if="navsub==2" v-model="options.groupid" size="mini" class="memselect" @change="getdata()">
                        <el-option :label="$common.dicword('allclass')" :value="-1"></el-option>
                        <el-option v-for="item in grouplist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                        <el-option :label="$common.dicword('onlynoclass')" :value="-2"></el-option>
                    </el-select>

                    <el-input :placeholder="$common.dicword('keyword')" size="mini" suffix-icon="el-icon-search" class="memsearch" v-model="options.kw" @change="getdata()" @keyup.enter.native="getdata()"></el-input>
                    <a class="mobtn" href="#" @click="add()">{{$common.dicword('add')}}</a>
                    <a class="mobtn" href="#" @click="del()">{{$common.dicword('del')}}</a>
                    <a class="mobtn" v-if="navsub==2" href="#" @click="changeclass()">{{$common.dicword('changeclass')}}</a>
                    <a class="mobtn" href="#" @click="outputcsv()">{{$common.dicword('output')}}</a>
                    <el-upload action="" class="ff-uploader" accept=".csv" ref="upload" :multiple="false" :show-file-list="false" :with-credentials="true" :auto-upload="false" :on-change="importcsv">
                        <span class="mobtn">{{$common.dicword('import')}}</span>
                    </el-upload>
                </template>

            </div>

            <div class="schoolinfo" v-if="navsub==0">
                <div v-if="!me.x_isedit" class="view">
                    <dl><dt>{{$common.dicword('simpletitle',true)}}</dt><dd v-html="me.title"></dd></dl>
                    <dl><dt>{{$common.dicword('fulltitle',true)}}</dt><dd v-html="me.titlefull"></dd></dl>
                    <dl><dt>{{$common.dicword('address',true)}}</dt><dd v-html="me.address"></dd></dl>
                    <dl><dt>{{$common.dicword('linkman',true)}}</dt><dd v-html="me.linkman"></dd></dl>
                    <dl><dt>{{$common.dicword('contact',true)}}</dt><dd v-html="me.contact"></dd></dl>
                    <dl><dt>{{$common.dicword('licences',true)}}</dt><dd>{{licences}}/{{me.licences}}<dd></dd></dl>
                    <dl><dt>{{$common.dicword('limitdate',true)}}</dt><dd>{{$common.basic.dateformat(me.datebegin)}}/{{$common.basic.dateformat(me.dateend)}}</dd></dl>
                    <dl>
                        <dt>{{$common.dicword('openfunction',true)}}</dt>
                        <dd>
                            <span>{{$common.dicword('olr')}}</span>
                            <span class="cellpart" v-if="me.hastdl">{{$common.dicword('tdl')}}</span>
                            <span class="cellpart" v-if="me.hastsr">{{$common.dicword('tsr')}}</span>
                        </dd>
                    </dl>
                    <dl><dt>{{$common.dicword('opencourse',true)}}</dt><dd><a href="#" @click="isshowtopic=true">{{$common.dicword('view')}}</a></dd></dl>
                    <dl><dt>&nbsp;</dt><dd><a href="#" class="btn1" @click="me.x_isedit=true">{{$common.dicword('modify')}}</a> </dd></dl>
                </div>
                <div v-else class="edit">
                    <dl><dt>{{$common.dicword('simpletitle',true)}}</dt><dd><el-input v-model="me.title" maxlength="50"></el-input></dd></dl>
                    <dl><dt>{{$common.dicword('fulltitle',true)}}</dt><dd><el-input v-model="me.titlefull" maxlength="100"></el-input></dd></dl>
                    <dl><dt>{{$common.dicword('address',true)}}</dt><dd><el-input v-model="me.address" maxlength="50"></el-input></dd></dl>
                    <dl><dt>{{$common.dicword('linkman',true)}}</dt><dd><el-input v-model="me.linkman" maxlength="50"></el-input></dd></dl>
                    <dl><dt>{{$common.dicword('contact',true)}}</dt><dd><el-input v-model="me.contact" maxlength="50"></el-input></dd></dl>

                    <dl><dt>&nbsp;</dt><dd class="btns"><a href="#" class="btn1" @click="saveschool">{{$common.dicword('save')}}</a><a href="#" class="btncancel" @click="me.x_isedit=false">{{$common.dicword('cancel')}}</a></dd></dl>
                </div>


            </div>

            <div class="membermainwrap" v-else-if="navsub==1">
                <dl class="mylist mylistheader">
                    <dd class="x0"> <el-checkbox v-model="ischeckall1" @change="checkall1"></el-checkbox></dd>
                    <dd>{{$common.dicword('title')}}</dd>
                    <dd class="x2">{{$common.dicword('course')}}</dd>
                    <dd>{{$common.dicword('tplevel')}}</dd>
                    <dd v-if="me.hastsr">{{$common.dicword('tsr')}}</dd>
                </dl>

                <dl class="mylist" v-for="item in classlist" :key="item.id">
                    <dd class="x0"> <el-checkbox v-model="item.x_ischeck"></el-checkbox></dd>
                    <dd><a href="#" @click="editgroup(item)"><span v-html="$common.langinfo(item.title,item.title_en)"></span></a> </dd>
                    <dd class="x2">{{item.x_topics.join(' ')}}</dd>
                    <dd>{{item.x_levtitle}}</dd>
                    <dd v-if="me.hastsr">{{$common.chint2bool(item.hastsr)}}</dd>
                </dl>

                <div class="ffpage">
                    <el-pagination :small="$store.getters.issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                    </el-pagination>
                </div>
            </div>

            <div class="membermainwrap" v-else-if="navsub==2">
                <dl class="mylist mylistheader">
                    <dd class="x0"> <el-checkbox v-model="ischeckall2" @change="checkall2"></el-checkbox></dd>
                    <dd>{{$common.dicword('username')}}</dd>
                    <dd>{{$common.dicword('realname')}}</dd>
                    <dd>{{$common.dicword('nickname')}}</dd>

                    <dd>{{$common.dicword('mobile')}}</dd>
                    <dd>{{$common.dicword('gender')}}</dd>
                    <dd>{{$common.dicword('infoclass')}}</dd>
                    <dd>{{$common.dicword('disabled')}}</dd>
                </dl>

                <dl class="mylist" v-for="item in learnerlist" :key="item.id">
                    <dd class="x0"> <el-checkbox v-model="item.x_ischeck"></el-checkbox></dd>
                    <dd><fflearner :info="item" :isusername="true" @aftersave="getdata()"></fflearner></dd>
                    <dd v-html="item.realname"></dd>
                    <dd v-html="item.showname"></dd>

                    <dd>{{item.mobile}}</dd>
                    <dd>{{$common.chgender(item.sex)}}</dd>
                    <dd>{{item.x_classtitle}}</dd>
                    <dd>{{$common.chint2bool(item.ischeck?0:1)}}</dd>
                </dl>

                <div class="ffpage">
                    <el-pagination :small="$store.getters.issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                    </el-pagination>
                </div>
            </div>

            <div class="membermainwrap" v-else-if="navsub==3">
                <dl class="mylist mylistheader">
                    <dd class="x0"> <el-checkbox v-model="ischeckall3" @change="checkall3"></el-checkbox></dd>
                    <dd>{{$common.dicword('username')}}</dd>
                    <dd>{{$common.dicword('realname')}}</dd>
                    <dd>{{$common.dicword('nickname')}}</dd>

                    <dd>{{$common.dicword('mobile')}}</dd>
                    <dd>{{$common.dicword('gender')}}</dd>
                    <dd>{{$common.dicword('admin')}}</dd>
                    <dd>{{$common.dicword('disabled')}}</dd>
                </dl>

                <dl class="mylist" v-for="item in teacherlist" :key="item.id">
                    <dd class="x0"> <el-checkbox v-model="item.x_ischeck"></el-checkbox></dd>
                    <dd><fflearner :info="item" :isusername="true" :isteacher="true" @aftersave="getdata()"></fflearner></dd>
                    <dd v-html="item.realname"></dd>
                    <dd v-html="item.showname"></dd>

                    <dd>{{item.mobile}}</dd>
                    <dd>{{$common.chgender(item.sex)}}</dd>
                    <dd>{{$common.chint2bool(item.isadmin)}}</dd>
                    <dd>{{$common.chint2bool(item.ischeck?0:1)}}</dd>
                </dl>

                <div class="ffpage">
                    <el-pagination :small="$store.getters.issmall" v-if="res.recordcount>res.ps" :background="true" :current-page.sync="res.cpage" :page-size="res.ps" layout=" prev, pager, next" :total="res.recordcount" @current-change="getdata">
                    </el-pagination>
                </div>
            </div>



            <el-dialog v-if="isshowtopic" :visible.sync="isshowtopic" top="0px" class="mydialog3">
                <div class="sdschooltopicwrap">
                    <myScroll class="scroll">
                        <div class="sdschooltopic ">
                            <dl v-for="item in modulelist" :key="item.id">
                                <dt><span v-html="item.title"></span><span v-html="item.titlefull"></span></dt>
                                <dd v-for="item2 in item.x_topiclist" :key="item2.id">
                                    <span v-html="item2.title"></span><span v-html="item2.titlefull"></span>
                                </dd>
                            </dl>
                        </div>
                    </myScroll>
                </div>
            </el-dialog>

            <el-dialog v-if="isshowgroup" :visible.sync="isshowgroup" top="0px" :append-to-body="true">
                <div class="mysubform modulewrap">
                    <dl><dt>{{$common.dicword('title',true)}}</dt><dd><el-input v-model="groupinfo.title" maxlength="20"></el-input></dd></dl>
                    <dl>
                        <dt>{{$common.dicword('tplevel',true)}}</dt>
                        <dd>
                            <el-select v-model="groupinfo.plev">
                                <el-option :label="$common.dicword('any')" :value="-1"></el-option>
                                <el-option v-for="item in tplevlist" :key="item.id" :label="item.title" :value="item.kv"></el-option>
                            </el-select>
                        </dd>
                    </dl>
                    <dl v-if="me.hastsr" class="x2"><dt>{{$common.dicword('tsr',true)}}</dt><dd> <el-switch v-model="groupinfo.hastsr" :active-value="1" :inactive-value="0"></el-switch></dd></dl>
                    <dl class="x2">
                        <dt>{{$common.dicword('topic',true)}}</dt>
                        <dd>
                            <el-checkbox-group v-model="groupinfo.topicids" class="checklist">
                                <div class="checklisttopic" v-for="item in topiclist" :key="item.id">
                                    <el-checkbox :label="item.id">{{item.title}}</el-checkbox>
                                </div>
                            </el-checkbox-group>
                        </dd>
                    </dl>
                    <div class="btns">
                        <a href="#" @click="savegroup()">{{$common.dicword('save')}}</a>
                        <a href="#" class="cancel" @click="isshowgroup=false">{{$common.dicword('cancel')}}</a>
                    </div>
                </div>
            </el-dialog>

            <el-dialog v-if="isshowlearner" :visible.sync="isshowlearner" top="0px" class="mydialogprofile modulewrap">
                <fflearnerdetail :isteacher="false" :groupid="options.groupid" :schoolid="options.schoolid" @aftersave="getdata()"></fflearnerdetail>
            </el-dialog>

            <el-dialog v-if="isshowteacher" :visible.sync="isshowteacher" top="0px" class="mydialogprofile modulewrap">
                <fflearnerdetail :isteacher="true" :schoolid="options.schoolid" @aftersave="getdata()"></fflearnerdetail>
            </el-dialog>
            <el-dialog v-if="isshowprompt" :visible.sync="isshowprompt" top="0px">
                <div class="promptwrap">
                    <div class="prompttitle">
                        {{$common.dicword('changeclass')}}
                    </div>
                    <div class="promptform">
                        <el-select v-model="changegroupid">
                            <el-option v-for="item in grouplist" :key="item.id" :label="$common.langinfo(item.title,item.title_en)" :value="item.id"></el-option>
                            <el-option :label="$common.dicword('onlynoclass')" :value="-2"></el-option>
                        </el-select>
                    </div>
                    <div class="promptbtns">
                        <a href="#" class="btn1" @click="changeclasssave">{{$common.dicword('confirm')}}</a><a href="#" class="btncancel" @click="isshowprompt=false">{{$common.dicword('cancel')}}</a>
                    </div>
                </div>
            </el-dialog>
        </div>
    </Cmembernav>
</template>

<script>
    import Papa from 'papaparse'

    import { mixinmember } from "@/mixin/mixin"
    export default {
        name: 'school',
        mixins: [mixinmember],
        data() {
            return {
                curnavkv: 200,
                me: {},
                licences: 0,
                isshowtopic: false,
                schoollist: [],
                grouplist: [],
                modulelist: [],
                topiclist: [],
                options: {
                    schoolid: -1,
                    groupid: -1,
                    kw: ''
                },
                classlist: [],
                learnerlist: [],
                teacherlist: [],
                tplevlist: [],

                ischeckall1: false,
                ischeckall2: false,
                ischeckall3: false,
                isshowgroup: false,
                groupinfo: { 'id': 0, 'title': '', 'plev': -1, 'topicids': [], 'hastsr': 0 },
                isshowlearner: false,
                isshowteacher: false,
                isshowprompt: false,
                changegroupid: 0
            };
        },
        computed: {
            isexpert: function () {
                return this.schoollist.length > 1;
            }
        },
        methods: {
            getdata: function (v) {
                if (v != undefined) {
                    this.navsub = v;
                }


                switch (this.navsub) {
                    case 0:
                        this.getschool();
                        break;
                    case 1:
                        this.getclass();
                        break;
                    case 2:
                        this.getlearner();
                        break;
                    case 3:
                        this.getteacher();
                        break;
                }
            },
            add: function () {
                switch (this.navsub) {
                    case 1:
                        this.groupinfo = { 'id': 0, 'title': '', 'plev': -1, 'topicids': [], 'hastsr': 0 };
                        this.isshowgroup = true;
                        break;
                    case 2:
                        this.isshowlearner = true;
                        break;
                    case 3:
                        this.isshowteacher = true;
                        break;
                }
            },
            getids(mylist) {

                let ids = [];
                this.$common.each(mylist, item => {
                    if (item.x_ischeck) {
                        ids.push(item.id);
                    }
                });
                return ids;
            },
            del: function () {
                this.$common.confirm("confirmdel", () => {
                    let mylist;
                    let act;
                    let api = '';
                    switch (this.navsub) {
                        case 1:
                            mylist = this.classlist;
                            act = 'te_admin_classdel'
                            break;
                        case 2:
                            mylist = this.learnerlist;
                            api = 'member';
                            act = 'mdel'
                            break;
                        case 3:
                            mylist = this.teacherlist;
                            api = 'member';
                            act = 'mdel'
                            break;
                    }

                    let ids = this.getids(mylist);
                    if (this.$common.basic.isarrayexist(ids)) {

                        let jsondata = {
                            'postdata': { 'api': api, 'act': act, 'ids': ids.join(), 'data': { 'schoolid': this.options.schoolid } }
                        };
                        this.$common.post(jsondata, () => {
                            this.getdata();
                        });
                    }
                    else {
                        this.$common.alert('needdata');
                    }
                })
            },
            changeclass: function () {
                let ids = this.getids(this.learnerlist);
                if (this.$common.basic.isarrayexist(ids)) {
                    this.isshowprompt = true;
                }
                else {
                    this.$common.alert('needdata');
                }
            },
            changeclasssave: function () {
                let ids = this.getids(this.learnerlist);
                if (this.$common.basic.isarrayexist(ids)) {
                    let jsondata = {
                        'postdata': {
                            'act': 'te_admin_changeclass', 'ids': ids.join(), 'data': { 'groupid': this.changegroupid, 'schoolid': this.options.schoolid }
                        }
                    };
                    this.$common.post(jsondata, () => {
                        this.getdata();
                        this.isshowprompt = false;
                    });
                }
                else {
                    this.$common.alert('needdata');
                }
            },
            outputcsv: function () {
                let outdata = [];
                let outtitle = '';
                switch (this.navsub) {
                    case 1:
                        this.$common.each(this.classlist, item => {
                            let outobj = {};

                            outobj[this.$common.dicword('title')] = item.title;
                            outobj[this.$common.dicword('course')] = item.x_topics.join();
                            outobj[this.$common.dicword('tplevel')] = item.x_levtitle;
                            outobj[this.$common.dicword('tsr')] = this.$common.chint2bool(item.tsr);

                            outdata.push(outobj);
                        });
                        outtitle = this.$common.dicword('infoclass');
                        break;
                    case 2:
                        this.$common.each(this.learnerlist, item => {
                            let outobj = {};


                            outobj[this.$common.dicword('username')] = item.username;
                            outobj[this.$common.dicword('realname')] = this.$common.basic.strunformat(item.realname);
                            outobj[this.$common.dicword('nickname')] = this.$common.basic.strunformat(item.showname);
                            outobj[this.$common.dicword('pwd')] = '';
                            outobj[this.$common.dicword('infoclass')] = item.x_classtitle;

                            outobj[this.$common.dicword('mobile')] = item.mobile;
                            outobj[this.$common.dicword('birth')] = this.$common.basic.dateformat(item.birth);
                            outobj[this.$common.dicword('gender')] = this.$common.chgender(item.sex);
                            outobj[this.$common.dicword('address')] = item.address;
                            outobj[this.$common.dicword('disabled')] = this.$common.chint2bool(item.ischeck ? 0 : 1);

                            outdata.push(outobj);
                        });
                        outtitle = this.$common.dicword('learner');
                        break;
                    case 3:
                        this.$common.each(this.teacherlist, item => {
                            let outobj = {};

                            outobj[this.$common.dicword('username')] = item.username;
                            outobj[this.$common.dicword('realname')] = this.$common.basic.strunformat(item.realname);
                            outobj[this.$common.dicword('nickname')] = this.$common.basic.strunformat(item.showname);
                            outobj[this.$common.dicword('pwd')] = '';
                            outobj[this.$common.dicword('admin')] = this.$common.chint2bool(item.isadmin);

                            outobj[this.$common.dicword('mobile')] = item.mobile;
                            outobj[this.$common.dicword('birth')] = this.$common.basic.dateformat(item.birth);
                            outobj[this.$common.dicword('gender')] = this.$common.chgender(item.sex);
                            outobj[this.$common.dicword('address')] = item.address;
                            outobj[this.$common.dicword('disabled')] = this.$common.chint2bool(item.ischeck ? 0 : 1);

                            outdata.push(outobj);
                        });
                        outtitle = this.$common.dicword('teacher');
                        break;
                }

                var csv = Papa.unparse(outdata);
                let content = new Blob(["\ufeff" + csv]);
                let urlObject = window.URL || window.webkitURL || window;
                let url = urlObject.createObjectURL(content);
                let el = document.createElement("a");
                el.href = url;
                el.download = outtitle + ".csv";
                el.click();
                urlObject.revokeObjectURL(url);
            },
            importcsv: function (file) {
                if (file === undefined) {
                    return
                }

                let act = '';
                let api = '';
                var reader = new FileReader();
                reader.readAsDataURL(file.raw);
                reader.onload = () => {
                    Papa.parse(file.raw, {
                        encoding: "gb2312",
                        skipEmptyLines: 'greedy',
                        complete: res => {
                            let data = res.data;
                            if (data[data.length - 1] == "") {
                                data.pop();
                            }

                            let importdata = [];
                            let errrow = [];

                            switch (this.navsub) {
                                case 1:
                                    this.$common.each(data, (item, index) => {
                                        if (index > 0) {
                                            let importobj = {};
                                            let errvalue = [];

                                            importobj.title = item[0];
                                            let topics = item[1];
                                            let topicids = [];
                                            if (topics) {
                                                this.$common.each(this.topiclist, item2 => {
                                                    if (this.$common.basic.ffcontain(topics, item2.title)) {
                                                        topicids.push(item2.id);
                                                    }
                                                });
                                            }
                                            importobj.topicids = topics ? topicids.join() : '';
                                            let plev = item[2];
                                            let levobj = this.$common.basic.fffind(this.tplevlist, 'title', plev);
                                            if (this.$common.basic.isobjexist(levobj)) {
                                                importobj.plev = levobj.kv;
                                            }
                                            else {
                                                importobj.plev = 0;
                                            }
                                            importobj.hastsr = this.$common.chstr2boolint(item[3]);
                                            importdata.push(importobj);

                                            if (!importobj.title) {
                                                errvalue.push(this.$common.dicword('title'));
                                            }


                                            if (this.$common.basic.isarrayexist(errvalue)) {
                                                errrow.push({ 'rowsn': (index + 1), 'msg': errvalue });
                                            }
                                        }

                                    });
                                    act = 'te_admin_classsavelist';
                                    break;
                                case 2:
                                    this.$common.each(data, (item, index) => {
                                        if (index > 0) {
                                            let importobj = {};
                                            let errvalue = [];

                                            importobj.username = item[0];
                                            importobj.realname = item[1];
                                            importobj.showname = item[2];
                                            importobj.pwd = item[3];
                                            let classtitle = item[4];
                                            let classobj = this.$common.basic.fffind(this.grouplist, 'title', classtitle);
                                            if (this.$common.basic.isobjexist(classobj)) {
                                                importobj.groupid = classobj.id;
                                            }
                                            else {
                                                importobj.groupid = 0;
                                            }
                                            importobj.mobile = item[5];
                                            importobj.birth = this.$common.basic.dateformat(item[6]);
                                            if (!importobj.birth) {
                                                importobj.birth = '1900-1-1';
                                            }
                                            importobj.sex = this.$common.chstr2genderint(item[7]);
                                            importobj.addr = item[8];
                                            importobj.ischeck = this.$common.chstr2boolint(item[9]) ? 0 : 1;
                                            importdata.push(importobj);

                                            if (!importobj.username) {
                                                errvalue.push(this.$common.dicword('username'));
                                            }
                                            if (!importobj.realname) {
                                                errvalue.push(this.$common.dicword('realname'));
                                            }


                                            if (this.$common.basic.isarrayexist(errvalue)) {
                                                errrow.push({ 'rowsn': (index + 1), 'msg': errvalue });
                                            }
                                        }

                                    });
                                    act = 'mprofilesavelist';
                                    api = 'member';
                                    break;
                                case 3:
                                    this.$common.each(data, (item, index) => {
                                        if (index > 0) {
                                            let importobj = {};
                                            let errvalue = [];

                                            importobj.username = item[0];
                                            importobj.realname = item[1];
                                            importobj.showname = item[2];
                                            importobj.pwd = item[3];
                                            importobj.isadmin = this.$common.chstr2boolint(item[4]);
                                            importobj.mobile = item[5];
                                            importobj.birth = this.$common.basic.dateformat(item[6]);
                                            if (!importobj.birth) {
                                                importobj.birth = '1900-1-1';
                                            }
                                            importobj.sex = this.$common.chstr2genderint(item[7]);
                                            importobj.addr = item[8];

                                            importobj.ischeck = this.$common.chstr2boolint(item[9]) ? 0 : 1;

                                            importdata.push(importobj);

                                            if (!importobj.username) {
                                                errvalue.push(this.$common.dicword('username'));
                                            }
                                            if (!importobj.realname) {
                                                errvalue.push(this.$common.dicword('realname'));
                                            }


                                            if (this.$common.basic.isarrayexist(errvalue)) {
                                                errrow.push({ 'rowsn': (index + 1), 'msg': errvalue });
                                            }
                                        }

                                    });
                                    act = 'mprofilesavelist2';
                                    api = 'member';
                                    break;
                            }


                            if (this.$common.basic.isarrayexist(errrow)) {
                                let msg = "";
                                this.$common.each(errrow, item => {
                                    msg += 'Error ' + item.rowsn + ': ' + item.msg.join() + '<br />';
                                });
                                this.$common.alert(msg);
                            }
                            else {

                                if (this.$common.basic.isarrayexist(importdata)) {
                                    let jsondata = {
                                        'postdata': { 'api': api, 'act': act, 'pid': this.options.schoolid, 'data': importdata }
                                    };
                                    this.$common.post(jsondata, (res) => {
                                        this.$common.each(res.infodataerr, item => {
                                            this.$common.alert('Error ' + item.id + ': ' + this.$common.dicword(item.title));
                                        })
                                        this.getdata();

                                    });
                                }

                            }

                        }
                    });
                };
            },
            editgroup: function (item) {

                this.groupinfo = { 'id': item.id, 'title': item.title, 'plev': item.plev, 'topicids': item.topicids ? item.topicids.split(',') : [], 'hastsr': item.hastsr };
                let topicids = [];
                this.$common.each(this.groupinfo.topicids, item => {
                    topicids.push(this.$common.basic.chstr2int(item));
                });
                this.groupinfo.topicids = topicids;

                this.isshowgroup = true;
            },
            saveschool: function () {
                let jsondata = {
                    'postdata': { 'act': 'te_admin_schoolsave', 'id': this.me.id, 'data': { 'title': this.me.title, 'titlefull': this.me.titlefull, 'linkman': this.me.linkman, 'contact': this.me.contact, 'address': this.me.address } }
                };
                this.$common.post(jsondata, () => {
                    this.me.x_isedit = false;

                });

            },
            savegroup: function () {
                let c_groupinfo = this.$common.basic.jsonclone(this.groupinfo);
                c_groupinfo.topicids = c_groupinfo.topicids.join();
                c_groupinfo.schoolid = this.options.schoolid;
                let jsondata = {
                    'postdata': { 'act': 'te_admin_classsave', 'id': this.groupinfo.id, 'data': c_groupinfo }
                };
                this.$common.post(jsondata, () => {
                    this.isshowgroup = false;
                    this.getdata();
                });
            },
            getschool: function () {
                let jsondata = { 'postdata': { 'act': 'te_admin_school', 'data': this.options } };
                this.$common.post(jsondata, res => {
                    res.infodata.x_isedit = false;

                    this.$common.each(res.infodatamodule, item => {
                        item.x_topiclist = this.$common.basic.fffilter(res.infodatatopic, 'moduleid', item.id);

                    });

                    this.me = res.infodata;
                    this.licences = res.licences;
                    this.modulelist = res.infodatamodule;
                    this.topiclist = res.infodatatopic;
                    this.schoollist = res.infodataschoollist;
                    if (this.options.schoolid <= 0) {

                        this.options.schoolid = this.me.id;
                    }
                });
            },
            selectschool: function () {
                this.options.groupid = -1;
                this.getdata();
            },
            getclass: function () {
                this.isnorecord = false;
                let jsondata = { 'postdata': { 'act': 'te_admin_class', 'data': this.options } };

                this.$common.post(jsondata, res => {

                    this.$common.each(res.infodata, item => {
                        item.x_ischeck = false;
                        let levobj = this.$common.basic.fffind(res.infodatatplev, 'kv', item.plev);
                        item.x_levtitle = this.$common.basic.isobjexist(levobj) ? levobj.title : this.$common.dicword('any');

                        item.x_topics = [];
                        if (this.$common.basic.isarrayexist(this.topiclist) && item.topicids) {
                            let topics = this.topiclist.filter(item2 => this.$common.basic.ffcontain(item.topicids, item2.id));
                            this.$common.each(topics, item3 => {
                                item.x_topics.push(item3.title);
                            });
                        }
                    });

                    this.classlist = res.infodata;
                    this.tplevlist = res.infodatatplev;

                    this.isnorecord = !this.$common.basic.isarrayexist(res.infodata);
                });
            },
            getlearner: function () {
                this.isnorecord = false;
                let jsondata = { 'postdata': { 'act': 'te_admin_learner', 'data': this.options } };

                this.$common.post(jsondata, res => {

                    this.$common.each(res.infodata, item => {
                        item.x_ischeck = false;
                        let obj = this.$common.basic.fffind(res.infodatagroup, 'id', item.groupid);
                        item.x_classtitle = this.$common.basic.isobjexist(obj) ? this.$common.dicword(obj.title, obj.title_en) : '-';
                    });
                    this.grouplist = res.infodatagroup;
                    this.learnerlist = res.infodata;
                    this.isnorecord = !this.$common.basic.isarrayexist(res.infodata);


                    this.changegroupid = this.$common.basic.isarrayexist(this.grouplist) ? this.grouplist[0].id : '';
                });
            },
            getteacher: function () {
                this.isnorecord = false;
                let jsondata = { 'postdata': { 'act': 'te_admin_teacher', 'data': this.options } };

                this.$common.post(jsondata, res => {

                    this.$common.each(res.infodata, item => {
                        item.x_ischeck = false;

                    });

                    this.teacherlist = res.infodata;
                    this.isnorecord = !this.$common.basic.isarrayexist(res.infodata);
                });
            },
            checkall1: function () {

                this.$common.each(this.classlist, item => {
                    item.x_ischeck = this.ischeckall1;
                });
            },
            checkall2: function () {
                this.$common.each(this.learnerlist, item => {
                    item.x_ischeck = this.ischeckall2;
                });
            },
            checkall3: function () {
                this.$common.each(this.teacherlist, item => {
                    item.x_ischeck = this.ischeckall3;
                });
            }
        },
        mounted() {
            this.getdata();
        }
    }

</script>
